import { filter } from "rxjs/operators";
import { AwsService } from "./../../../providers/appsyncservice/aws.service";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-assigned-driver",
  templateUrl: "./assigned-driver.component.html",
  styleUrls: ["./assigned-driver.component.css"]
})
export class AssignedDriverComponent implements OnInit {
  displayAssignedDriverValue = 0;
  assignDriverList: any = [];
  errorMsg: string = "Loading... Please wait...";
  showRnSearch: boolean = false;
  showDriverSearch: boolean = false;
  showSearchForm:boolean=false;
  showEditForm: boolean = false;
  public formGroup: FormGroup;
  isValid: any = true;
  usernameSearchErr = "";
  driverSearchErr = "";
  searchedUserData: any = [];
  searchedDriverData: any = [];
  assignDriverItem: any;
  driverMasterAvailable: boolean;
  submitButtontxt: string = "Submit";
  showSubmitbtn: boolean = true;

  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems=10;

  constructor(public aws: AwsService) {
    this.getAssignedDriver();
  }

  ngOnInit() {
    this.initiateFormGroup();
  }

  initiateFormGroup() {
    this.formGroup = new FormGroup({
      id: new FormControl(),
      search_username: new FormControl(),
      search_driver_username: new FormControl(),
      assigned_date: new FormControl(),
      end_date: new FormControl(),
      driver_id: new FormControl(),
      username: new FormControl(),
      user_pid: new FormControl(),
      status: new FormControl(),
      ex_data: new FormControl(),
      created_date: new FormControl(),
      updated_date: new FormControl()
    });
  }

  getAssignedDriver() {
    this.aws
      .getAssignedDriverList()
      .then(res => {
        console.log("getAssignedDriver", res);
        this.constructData(res);
        if (res.length == 0)
          this.errorMsg =
            "Sorry!. No Assignation data is found. Add Something and check here";
      })
      .catch(err => {
        this.errorMsg = "Sorry!. Something went wrong! Try again!";
      });
  }

  constructData(data){
    this.assignDriverList=[]
    var oplist=[]
    for(var i in data){
      data[i].sno=+i+1;
      oplist.push(data[i])
    }
    this.assignDriverList=oplist;
  }

  gotoAssignDriver() {
    this.displayAssignedDriverValue = 1;
    this.showRnSearch = true;
    this.submitButtontxt = "ASSIGN";
    this.showSubmitbtn = true;
    this.showSearchForm=true;
    this.resetForm();
    console.log("searchUsername", this.formGroup.controls);
  }
  assignDriverDataSubmit() {
    console.log("this.formGroup.value.id", this.formGroup.value.id);
    if (this.formGroup.value.id == null) {
      this.aws
        .CreateDriverAssignData(this.formGroup.value)
        .then(res => {
          this.driverMasterEntry();
          this.resetForm();
          this.getAssignedDriver();

          this.displayAssignedDriverValue = 0;
        })
        .catch(err => {
          alert("Sorry Something went wrong Try again!");
        });
    } else {
      this.aws
        .UpdateDriverAssignData(this.formGroup.value)
        .then(res => {
          this.resetForm();
          this.getAssignedDriver();
          this.displayAssignedDriverValue = 0;
        })
        .catch(err => {
          console.log("UpdateDriverAssignData", err, this.formGroup.value);
          alert("Sorry Something went wrong Try again!");
        });
    }
  }
  resetForm() {
    this.formGroup.reset("");
    this.usernameSearchErr = "";
    this.driverSearchErr = "";
    this.showDriverSearch = false;
    this.showEditForm = false;
    this.searchedUserData = [];
    this.searchedDriverData = [];
  }
  searchUsername() {
    var driverAssigneduser = this.assignDriverList.filter(res => {
      return (
        res.username.toUpperCase() ===
          this.formGroup.value.search_username.toUpperCase() &&
        res.status === "ASSIGN"
      );
    });

    if (driverAssigneduser.length > 0) {
      var driverAssignedData = driverAssigneduser[0];
      this.usernameSearchErr = `This username is having already assigned driver. Modify status as <b>UNASSIGN</b> and try again`;
    } else {
      console.log("searchUsername", this.formGroup.controls);
      this.usernameSearchErr = "Loading...! Please wait... ";
      this.aws
        .rnUserFilter(this.formGroup.value.search_username.toUpperCase())
        .then(result => {
          if (result.length == 0) {
            this.usernameSearchErr = "Username is not found. Try Different";
          } else {
            this.usernameSearchErr = "";
            this.searchedUserData = result;
            this.showDriverSearch = true;
            this.formGroup.patchValue({
              status: "ASSIGN",
              username: this.searchedUserData[0].user_name,
              user_pid: this.searchedUserData[0].id
            });
          }
        })
        .catch(err => {
          console.log("err", err);
          this.usernameSearchErr = "Sorry!. Something went wrong! Try again!";
        });
    }
  }
  searchDriverUsername() {
    console.log("searchUsername", this.formGroup.value);

    // this.formGroup.value.search_username

    console.log(
      "search_driver_username",
      this.formGroup.value.search_driver_username
    );

    this.driverSearchErr = "Loading...! Please wait... ";

    this.aws
      .rnUserFilter(this.formGroup.value.search_driver_username.toUpperCase())
      .then(result => {
        if (result.length > 0) {
          if (result[0].user_type == 3) {
            var driverAssignedId = this.assignDriverList.filter(res => {
              return res.driver_id === result[0].id && res.status === "ASSIGN";
            });
            if (driverAssignedId.length > 0) {
              console.log("driverAssignedId", driverAssignedId);
              this.driverSearchErr =
                "This driver is already assigned to this user <b>" +
                driverAssignedId[0].username +
                "</b>";
            } else {
              var dt = new Date();
              this.driverSearchErr = "";
              this.searchedDriverData = result;
              this.showEditForm = true;
              this.formGroup.patchValue({
                assigned_date: formatDate(dt, "yyyy-MM-dd", "en"),
                driver_id: this.searchedDriverData[0].id,
                created_date: dt.toISOString(),
                updated_date: dt.toISOString()
              });
              this.getDriverbyId(result[0].id);
            }
          } else {
            this.driverSearchErr =
              "This account is not a Personal Driver! Try some Driver id";
          }
        } else {
          this.driverSearchErr = "Username is not found. Try Different";
        }
      })
      .catch(err => {
        console.log("err", err);
        this.driverSearchErr = "Sorry!. Something went wrong! Try again!";
      });
  }

  getDriverbyId(id) {
    console.log("getDriverbyId", id);
    this.aws
      .getDriverListbyPid(id)
      .then(res => {
        console.log("getDriverListbyPid", res, res.length);
        if (res.length > 0) this.driverMasterAvailable = true;
        else this.driverMasterAvailable = false;
      })
      .catch(err => {
        console.log("getDriverListbyPid", err);
      });
  }

  driverMasterEntry() {
    if (!this.driverMasterAvailable) {
      var dt = new Date();
      var data = {
        user_pid: this.formGroup.value.driver_id,
        driver_name: this.searchedDriverData[0].name,
        date_of_birth: null,
        driving_license_no: null,
        license_exp_date: null,
        vendor_name: null,
        is_active: "YES",
        is_assigned: this.formGroup.value.status === "ASSIGN" ? "YES" : "NO",
        ex_data: "FROM DRIVER ASSIGN",
        created_date: dt.toISOString(),
        updated_date: dt.toISOString()
      };

      console.log("driverMasterAvailable", data);
      this.aws
        .CreateDriverData(data)
        .then(res => {
          console.log("CreateDriverData", res);
        })
        .catch(err => {
          console.log("CreateDriverData", err);
        });
    }
  }

  setAssignedDriverItem(item) {
    var dt = new Date();
    var stat = item.status;
    var enddate = item.end_date;
    if (item.status == "ASSIGN") {
      this.submitButtontxt = "UNASSIGN";
      this.showSubmitbtn = true;
      stat = "UNASSIGN";
      enddate = formatDate(dt, "yyyy-MM-dd", "en");
    } else {
      this.showSubmitbtn = false;
    }
    this.searchedDriverData=null;
    this.searchedUserData=null;
    this.getDriverById(item.driver_id);
    this.getUserByuserName(item.username);
    this.formGroup.patchValue({
      id: item.id,
      assigned_date: item.assigned_date,
      end_date: enddate,
      driver_id: item.driver_id,
      username: item.username,
      user_pid: item.user_pid,
      status: stat,
      ex_data: item.ex_data,
      created_date: item.created_date,
      updated_date: dt.toISOString()
    });
    this.displayAssignedDriverValue = 1;
    this.showRnSearch = true;
    this.showDriverSearch = true;
    this.showSearchForm=false;
    this.showEditForm = true;
  }

getDriverById(id){
  this.aws.rnUserFilterById(id).then((res)=>{
    console.log("getDriverById",res);
      var result=[res]
      this.searchedDriverData = result;
  })
}

getUserByuserName(username){
  this.aws.rnUserFilter(username).then((res)=>{
    if(res.length>0){
      this.searchedUserData = res;
    }
  })
}


public sort(sortKey){
  this.sortKey = sortKey;
  this.sortReverse = !this.sortReverse;
}

public sortClass(sortKey){
  if(this.sortKey==sortKey){
    if(this.sortReverse){
      return 'fa fa-sort-desc';
    }
    else
    {
      return 'fa fa-sort-asc';
    }
  }
  else{
    return 'fa fa-sort';
  }
  
}

}
